import ImageComponent from './ImageComponent'
import MediaComponent from './MediaComponent'
import QuoteComponent from './QuoteComponent'
import RichTextComponent from './RichTextComponent'

export enum BlockTypeEnum {
  Media = 'shared.media',
  Quote = 'shared.quote',
  RichText = 'shared.rich-text',
}

export interface BlockModel {
  component: BlockTypeEnum
  id: number
}

export interface MediaBlockModel extends BlockModel, MediaComponent {}

export interface QuoteBlockModel extends BlockModel, QuoteComponent {}

export interface RichTextBlockModel extends BlockModel, RichTextComponent {}

export const toMediaBlockModel = (id: number, file: ImageComponent): MediaBlockModel => {
  const res: MediaBlockModel = {
    component: BlockTypeEnum.Media,
    id: id,
    file: file,
  }

  return res
}

export const toQuoteBlockModel = (id: number, title: string, body: string): QuoteBlockModel => {
  const res: QuoteBlockModel = {
    component: BlockTypeEnum.Quote,
    id: id,
    title: title,
    body: body,
  }

  return res
}

export const toRichTextBlockModel = (id: number, body: string): RichTextBlockModel => {
  const res: RichTextBlockModel = {
    component: BlockTypeEnum.RichText,
    id: id,
    body: body,
  }

  return res
}
